var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcWhiteCircle = function SvgIcWhiteCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Student-OnRamp - Dashboard - Final"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1215,
    transform: "translate(-1169 -277)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 5365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 5364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 5362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Progress Bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 335",
    x: -452,
    y: 9,
    width: 467,
    height: 3,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "currentColor"
  })))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcWhiteCircle);
export { ForwardRef as ReactComponent };